import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="auth-container">
          <div className="auth-card">
            <div className="auth-header">
              <div className="auth-logo">Services Anti-Trafic</div>
              <p className="auth-subtitle">Une erreur s'est produite</p>
            </div>
            
            <div className="auth-alert auth-alert-error">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <span className="text-lg">⚠️</span>
                </div>
                <div className="ml-3 flex-1">
                  <h3 className="text-sm font-medium text-red-800">
                    Erreur inattendue
                  </h3>
                  <div className="mt-1 text-sm text-red-700">
                    <p>Une erreur inattendue s'est produite. Veuillez rafraîchir la page.</p>
                  </div>
                  <div className="mt-3 flex space-x-2">
                    <button
                      onClick={() => window.location.reload()}
                      className="text-xs bg-red-100 hover:bg-red-200 text-red-800 px-2 py-1 rounded transition-colors"
                    >
                      Rafraîchir la page
                    </button>
                    <button
                      onClick={() => this.setState({ hasError: false, error: undefined, errorInfo: undefined })}
                      className="text-xs bg-red-100 hover:bg-red-200 text-red-800 px-2 py-1 rounded transition-colors"
                    >
                      Réessayer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
